// extracted by mini-css-extract-plugin
export default {"seasonTable":"SeasonTable_seasonTable__n62qf","header":"SeasonTable_header__XByFa","search":"SeasonTable_search__k0PgT","searchInput":"SeasonTable_searchInput__z0N8R"};